/**
 * Format a numeric amount as full currency (with symbol, e.g. "$1,500").
 * Use for copy/read-only display. For input values that have their own $ adornment, use formatCurrencyInputValue instead.
 */
export function formatCurrencyAmount(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
